var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-container",class:{ 'loader-opaque': _vm.isSubmitLoading }},[_c('div',{ref:"logoContainer",staticClass:"logo-container"})])
}
var staticRenderFns = []

export { render, staticRenderFns }